import * as React from 'react';

import {FeatureGateModalWrapper} from './feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function CallSummarizationFeatureGateModal(props: Props) {
    return (
        <FeatureGateModalWrapper
            isOpen={props.isOpen}
            onClose={props.onClose}
            title='Automatically summarize your calls'
            description='Turn your calls into concise summaries with ease.'
            bullets={[
                'Save time on note-taking and capture key points and action items.',
                'Stay focused on the conversation while the summary captures all the details.',
                'Easily access summaries to follow up on important topics and drive results.',
            ]}
            feature='summarization'
        />
    );
}
